import i18n from '@/base/i18n/index'
import { payerPaywallGuard } from '@/base/utils/payerPaywallGuard'

const MaintenanceComponent = () => import('@/base/views/Maintenance.vue')
const StartComponent = () => import('@/base/views/Start.vue')
const PayerPaywallComponent = () => import('@/base/views/PayerPaywall.vue')
const ResultComponent = () => import('@/base/views/Result.vue')
const VisadataComponent = () => import('@/base/views/Visadata.vue')
const ContinueComponent = () => import('@/base/views/Continue.vue')
const WaitComponent = () => import('@/base/views/Wait.vue')
const ErrorNotFoundComponent = () => import('@/base/views/404.vue')
const ErrorComponent = () => import('@/base/views/Error.vue')
const ConfirmationComponent = () => import('@/base/views/Confirmation.vue')
const SecureBackComponent = () => import('@/base/views/SecureBack.vue')
const RegulationsApprovalComponent = () => import('@/base/views/RegulationsApproval.vue')
const SessionTimeoutComponent = () => import('@/base/views/SessionTimeout.vue')
const PaywayErrorComponent = () => import('@/base/views/PaywayError.vue')

export const ROUTING = {
  start: '/start',
  continue: '/continue',
  payerPaywall: '/payer-paywall',
  wait: '/wait',
  confirmation: '/confirmation',
  result: '/result',
  error: '/error',
  visadata: '/visadata',
  errorNotFound: '/error/404',
  secureBack: '/secure-back',
  maintenance: '/maintenance',
  regulationsApproval: '/regulations-approval',
  sessionTimeout: '/session-timeout',
  paywayError: '/payway-error',
}

export const routes = [
  {
    path: ROUTING.maintenance,
    name: 'Maintenance',
    component: MaintenanceComponent,
    meta: {
      title: 'maintenance',
    },
  },
  {
    path: ROUTING.start + '/:apiToken',
    name: 'Start',
    component: StartComponent,
    props: true,
    meta: {
      title: 'start',
    },
  },
  {
    path: ROUTING.payerPaywall,
    name: 'PayerPaywall',
    component: PayerPaywallComponent,
    beforeEnter: payerPaywallGuard,
    meta: {
      title: 'payer-paywall',
    },
  },
  {
    path: ROUTING.result + '/:apiToken',
    name: 'Result',
    component: ResultComponent,
    props: true,
    meta: {
      title: 'result',
    },
  },
  {
    path: ROUTING.visadata + '/:apiToken/:idTransRemote',
    name: 'Visadata',
    component: VisadataComponent,
    props: true,
    meta: {
      title: 'visadata',
    },
  },
  {
    path: ROUTING.continue + '/:idTransRemote/:continueHash',
    name: 'Continue',
    props: true,
    component: ContinueComponent,
    meta: {
      title: 'continue',
    },
  },
  {
    path: ROUTING.wait + '/:apiToken/:idTransRemote',
    name: 'Wait',
    props: true,
    component: WaitComponent,
    meta: {
      title: 'wait',
    },
  },
  {
    path: ROUTING.errorNotFound,
    name: 'ErrorNotFound',
    props: true,
    component: ErrorNotFoundComponent,
    meta: {
      title: 'errorNotFound',
    },
  },
  {
    path: ROUTING.error + '/:errorHash?',
    name: 'Error',
    props: true,
    component: ErrorComponent,
    meta: {
      title: 'error',
    },
  },
  {
    path: ROUTING.confirmation,
    name: 'Confirmation',
    component: ConfirmationComponent,
    meta: {
      title: 'confirmation',
    },
  },
  {
    path: ROUTING.secureBack + '/:apiToken',
    name: 'SecureBack',
    props: true,
    component: SecureBackComponent,
    meta: {
      title: 'secureBack',
    },
  },
  {
    path: ROUTING.regulationsApproval + '/:idTransRemote/:continueHash',
    name: 'RegulationsApprovalContinue',
    props: true,
    component: RegulationsApprovalComponent,
    meta: {
      title: 'regulationsApproval',
    },
  },
  {
    path: ROUTING.regulationsApproval + '/:apiToken',
    name: 'RegulationsApprovalStart',
    props: true,
    component: RegulationsApprovalComponent,
    meta: {
      title: 'regulationsApproval',
    },
  },
  {
    path: ROUTING.sessionTimeout,
    name: 'SessionTimeout',
    component: SessionTimeoutComponent,
    meta: {
      title: 'sessionTimeout',
    },
  },
  {
    path: ROUTING.paywayError,
    name: 'paywayError',
    component: PaywayErrorComponent,
    meta: {
      title: 'paywayError',
    },
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: ROUTING.errorNotFound,
  },
]

const PAGE_TITLE_KEYS = {
  base: 'page.title.base',
  start: 'page.title.start',
  payerPaywall: 'page.title.payerPaywall',
  result: 'page.title.result',
  visadata: 'page.title.visadata',
  continue: 'page.title.continue',
  wait: 'page.title.wait',
  confirmation: 'page.title.confirmation',
  error: 'page.title.error',
  errorNotFound: 'page.title.errorNotFound',
  secureBack: 'page.title.secureBack',
  maintenance: 'page.title.maintenance',
  regulationsApproval: 'page.title.regulationsApproval',
  frData: 'page.title.toTransferData',
  sessionTimeout: 'page.title.sessionTimeout',
  paywayError: 'page.title.paywayError',
}

// tłumaczenia rozwiązywane leniwie - każdy widok czyta 2-3 tytuły, a eager t() dla całej mapy
// tłumaczyło też klucze PL-only (page.title.payerPaywall) na każdym widoku i w każdym języku
export const pageTitle = () => {
  const titles = {}
  for (const [name, key] of Object.entries(PAGE_TITLE_KEYS)) {
    Object.defineProperty(titles, name, {
      enumerable: true,
      get: () => i18n.global.t(key),
    })
  }
  return titles
}
